import React from 'react'
import { Thor } from '../../compositions/Thor/Thor'
import { ContentWrapper } from '../ContentWrapper/ContentWrapper'
import { BaseCompositionProps } from '../types'
import { createRegisterableComposition } from '@news-mono/web-common'
import { ThemeMargins, ContainerWidth } from '../../__styling/settings/metrics'
import { ResponsiveContainer } from '../../content/Picture/responsive'

export interface ThorRouteProps extends BaseCompositionProps {
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    containerWidth?: ContainerWidth
    verticalSpacing?: keyof ThemeMargins
}

export const ThorRegistration = createRegisterableComposition<'main'>()(
    'thor',
    (contentAreas, props: ThorRouteProps) => (
        <ContentWrapper
            stretchColumns={props.stretchColumns}
            stretchSelf={props.stretchSelf}
        >
            <Thor {...props} mainContent={contentAreas.main} />
        </ContentWrapper>
    ),
    (
        _contentArea,
        {
            containerWidthRatios = { desktop: 1, tablet: 1, mobile: 1 },
        }: ThorRouteProps & ResponsiveContainer,
    ): ResponsiveContainer => {
        return {
            containerWidthRatios: {
                desktop: containerWidthRatios.desktop,
                tablet: containerWidthRatios.tablet,
                mobile: containerWidthRatios.mobile,
            },
        }
    },
)
